const translations: Record<string, Record<string, string>> = {
  es: {
    'Online Help/FAQs': 'Ayuda / FAQs',
    'Sales Process': 'Proceso Venta',
    Inbox: 'Bandeja',
    'Total Debt': 'Deuda Total',
    'Program Term': 'Duración del programa',
    'Monthly Payment': 'Pago Mensual',
    'Program Payment': 'Pago del programa',
    'Payer Status': 'Estado del pagador',
    'Program Cost': 'Costo del programa',
    'How Long?': '¿Cuánto tiempo?',
    Years: 'Años',
    Months: 'Meses',
    'Monthly Savings': 'Ahorro mensual',
    'Total Savings': 'Ahorro total',
    'Annual Payments': 'Pagos anuales',
    'Principal Savings': 'Ahorro en capital',
    'Total Paid So Far': 'Total pagado hasta ahora',
    'Time Saved': 'Tiempo ahorrado',
    'What you will Pay': 'Lo que pagarás',
    Reset: 'Reiniciar',
    month: 'mes',
    months: 'meses',
    State: 'Estado',
    'Loan Amount': 'Monto del préstamo',
    'Loan Term': 'Plazo del préstamo',
    'Loan Terms': 'Términos del préstamo',
    'Loan Monthly Payment': 'Pago mensual del préstamo',
  },
}

export default function translateControl(
  language: string = 'en',
  fragment: string,
): string {
  if (language == 'en') {
    return fragment
  }
  return (
    translations[language][fragment] ||
    `MISSING TRANSLATION - "${fragment}" in ${language}`
  )
}
